import React from "react";
import { useNavigate } from "react-router-dom";

import { NotFoundError } from "@ippon/shared-components";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return <NotFoundError onRetry={() => navigate("/")} />;
};

export default NotFoundPage;
